export default __webpack_public_path__ + "static/01-168ece4de2e4489d3c2ad5d1331b0668.jpg";